<template>
  <div>
    <div id="login">
      <a href="javascript:history.go(-1)" class="no-deco back-button-login" :class="isPhone ? 'raleway-semi-p14 px-3 mb-2' : 'raleway-semi-p24 mb-5'"> < Retour </a>
      <div class="content">
        <div class="content-form">
          <div class="header-modal headline">
            <h2 :class="isPhone ? 'merriweather-reg-30 heading pt-3' : 'merriweather-reg-40 heading'">La newsletter d’Hortense</h2>
            <p :class="isPhone ? 'merriweather-light-15 heading-title' : 'merriweather-light-24 heading-title'">Restez informé(e) de nos dernières actualités, conseils de voyage et inspirations.</p>
          </div>
          <form @submit.prevent="sendContact">
            <div :class="isPhone ? 'form-signup raleway-reg-p15 pt-2' : 'form-signup raleway-reg-p15 pt-5'">
              <div class="form-item">
                <div class="label-row">
                  <label for="last_name" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Nom*</label>
                  <span class="required-text raleway-reg-p15">( * champs obligatoires )</span>
                </div>
                <input v-model="newsletter.last_name" type="text" class="form-input" id="last_name" />
              </div>
              <div class="form-item">
                <label for="first_name" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Prénom*</label>
                <input v-model="newsletter.first_name" type="text" class="form-input" id="first_name" />
              </div>
              <div class="form-item">
                <label for="email" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">E-mail*</label>
                <input v-model="newsletter.email" type="text" class="form-input" id="email" />
              </div>
              <div class="form-item newsletter">
                <input type="checkbox" id="perso_info" value="perso_info" v-model="checkedItems" />
                <label for="perso_info" :class="isPhone ? 'raleway-reg-p15 text-gray' : 'raleway-reg-p20 text-gray'">
                  En cochant cette case, vous consentez à recevoir les actualités et propositions commerciales par voie électronique. Vous pouvez vous désinscrire à tout moment à travers le lien de désinscription.
                </label>
              </div>
              <button type="submit" :class="isPhone ? 'hortense-btn-primary raleway-bold-p14 mt-2 mb-4' : 'hortense-btn-primary raleway-bold-p25 mt-4'">S'ABONNER</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div :class="isPhone ? 'promo-page pt-5' : 'promo-page pt-5 px-5'">
      <p :class="isPhone ? 'text-center merriweather-reg-24' : 'text-center merriweather-reg-40'">Voyagez comme un invité privilégié avec le club hortense</p>
      <p :class="isPhone ? 'text-center raleway-reg-p15' : 'text-center merriweather-light-24'">
        Créez votre compte et rejoignez notre programme de fidélité pour profiter de services exclusifs, pensés pour faire de votre séjour une expérience inoubliable.
      </p>
      <div class="slider-wrapper pt-4 position-relative">
        <slither-slider :options="{ numberOfSlides: itemsPerPage, dots: false, controls: true, autoplay: false, loop: false, gap: isPhone ? 0 : 20 }">
          <div v-for="(offer, index) in visibleOffers" :key="index" class="offer">
            <div class="zoom-img-container">
              <img :src="offer.image" :alt="offer.title" class="offer-image zoom-img" />
            </div>
            <p :class="isPhone ? 'offer-title raleway-semi-p15' : 'offer-title raleway-bold-p16'">{{ offer.title }}</p>
          </div>
          <template slot="previous">
            <div class="previous-slide-button" v-show="currentStartIndex > 0" @click="prevSlide">
              <button class="nav-button left mb-5">&lt;</button>
            </div>
          </template>
          <template slot="next">
            <div class="next-slide-button" v-show="currentStartIndex + itemsPerPage < offers.length" @click="nextSlide">
              <button class="nav-button right mb-5">&gt;</button>
            </div>
          </template>
        </slither-slider>
      </div>
      <p :class="isPhone ? 'text-center address-p raleway-reg-p15' : 'text-center address-p raleway-reg-p15 pt-4'">
        Chaque adresse de notre sélection est minutieusement choisie pour vous offrir un accueil d’exception. Réservez dès maintenant sur notre site et profitez d'une expérience unique.
      </p>
      <button @click="visitLink('/inscription')" :class="isPhone ? 'cta-button mt-4 raleway-bold-p14' : 'cta-button mt-4 raleway-bold-p25'">
        CRÉER VOTRE COMPTE
      </button>
      <p class="learn-more" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p25'"><a href="https://www.hortense.green/programme-fidelite-club-hortense" class="learn-more">En savoir plus sur le Club Hortense</a></p>
      <p :class="isPhone ? 'disclaimer raleway-reg-p8' : 'disclaimer pt-4 raleway-reg-p15'">
        *Chaque hébergement propose des services exclusifs soigneusement sélectionnés. Consultez la page dédiée à l’hébergement pour découvrir les offres disponibles. Les détails peuvent varier d’un établissement à l’autre.
      </p>
    </div>
    <Modalsignup v-if="showModal" @close="showModal = false" />
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';
import Modalsignup from '../../components/modals/Modalsignup.vue';

export default {
  name: 'newsletterPage',
  components: {
    Modalsignup,
  },
  data() {
    return {
      newsletter: {
        email: '',
        last_name: '',
        first_name: ''
      },
      checkedItems: [],
      showModal: false,
      currentStartIndex: 0,
      offers: [
        { title: "Massage offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Massage+gratuit+service+exclusif+Hortense.jpg" },
        { title: "Petit déjeuner offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Petit+de%CC%81j+offert+service+exclusif+Hortense.jpg" },
        { title: "Dîner offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Di%CC%82ner+offert+service+exclusif+Hortense.jpg"},
        { title: "Surclassement de chambre", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Surclassement+de+chambre+service+exclusif+Hortense.jpg" },
        { title: "Surclassement de chambre", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Surclassement+de+chambre+service+exclusif+Hortense.jpg", only_desktop: true },
        { title: "Bouteille de champagne" ,image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Bouteille+de+champagne+service+exclusif+Hortense.jpg" },
        { title: "Dégustation de vin", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/De%CC%81gustation+de+vin+service+exclusif+Hortense.jpg" },
        { title: "Verre de bienvenue", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Verre+de+bienvenue+service+exclusif+Hortense.jpg" }
      ],
      currentStartIndex: 0
    };
  },
  computed: {
    visibleOffers() {
      if (this.isPhone) {
        return this.offers.filter(offer => !offer.only_desktop);
      }
      return this.offers;
    },
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    itemsPerPage() {
      return this.isPhone ? 2 : 4;
    }
  },
  methods: {
    visitLink(link) {
      window.open(link, '_blank');
    },
    async sendContact() {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'newsletter_signup',
        });
        const res = await fetcher.post('/newsletters/', { newsletter: this.newsletter, just_mail: true });
        alert('Subscribed successfully!');
        window.location.href = '/';
      } catch (e) {
        window.location.href = '/';
        alert('Subscription failed.');
      }
    },
    nextSlide() {
      if (this.currentStartIndex + this.itemsPerPage < this.offers.length) {
        this.currentStartIndex += this.itemsPerPage;
      }
    },
    prevSlide() {
      if (this.currentStartIndex - this.itemsPerPage >= 0) {
        this.currentStartIndex -= this.itemsPerPage;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  border: 1px solid #090808;
  box-sizing: border-box;
  width: 675px;
  padding: 0.75rem;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 44px;
    padding-left: 4%;
    padding-right: 4%;
  }
}
#login {
  height: auto;
  display: grid;
  background: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Fond+page+Newsletter+service+exclusif+Hortense.jpg");
  background-size: cover;
  padding: 135px 0;
  @media  screen and (max-width: 768px) {
    padding: 100px 26px 73px 27px;
    background-position: center;
  }
}

#login .form-signup label {
  margin-bottom: 0.5rem;
  white-space: normal;
  word-break: break-word;
  color: #333;
}
#login .form-signup input {
  padding: 0.75rem;
  border: 1px solid #090808;
  box-sizing: border-box;
  width: 675px;
  height: 87px;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 44px;
    padding-left: 4%;
    padding-right: 4%;
  }
}

.content {
  width: 994px !important;
  @media screen and (max-width: 768px) {
    width: 100% !important;
    overflow-y: hidden;
  }
}

.content-form {
  padding-bottom: 1rem !important;
  @media screen and (max-width: 768px) {
    padding: 0 !important;
    height: auto !important;
  }
}
.headline {
  text-align: center;
  line-height: 1.2;
  word-spacing: 2px;
}
.form-signup {
  width: 100%;
  max-width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  @media screen and (max-width: 480px) {
    padding: 0; 
  }
}
.form-signup .form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  width: 675px;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px !important;
  }
}
.form-signup label {
  margin-bottom: 0.5rem;
  white-space: normal;
  word-break: break-word;
  color: #333;
}
.required-text {
  color: #707070;
  opacity: 1;
}
.text-gray {
  color: #6D6A6A;
}
.hortense-btn-primary {
  width: 427px !important;
  @media screen and (max-width: 768px) {
    width: 97% !important;
  }
}
.promo-page {
  max-width: 1968px;
  background: #f7f7f7;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}
.description, .subtext {
  color: #090808;
  margin-bottom: 20px;
}
.disclaimer {
  color: #090808;
  text-align: start;
}
.offers {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: nowrap;
  gap: 20px;
  overflow: hidden;
}
.offer {
  flex: 0 0 auto;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;

  @media screen and (max-width: 768px) {
    padding: 0 5px;
  }
}
.slider-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  margin: 20px 0;
  background: #F7F7F7 0% 0% no-repeat padding-box;
  height: unset;
  padding: 0 60px;

  @media screen and (max-width: 768px) {
    padding: 0 50px;
  }

  @media screen and (max-width: 480px) {
    padding: 0 40px;
  }
}
.previous-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  z-index: 10;

  @media screen and (max-width: 768px) {
    left: 5px;
  }

  @media screen and (max-width: 480px) {
    left: 2px;
  }

  button {
    font-size: 3.5rem;
    color: #707070;
    border: none;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 2rem;
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 480px) {
      font-size: 1.5rem;
      width: 35px;
      height: 35px;
    }

    &:hover {
      color: #3B6152;
    }
  }
}
.next-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  z-index: 10;

  @media screen and (max-width: 768px) {
    right: 5px;
  }

  @media screen and (max-width: 480px) {
    right: 2px;
  }

  button {
    font-size: 3.5rem;
    color: #707070;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 2rem;
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 480px) {
      font-size: 1.5rem;
      width: 35px;
      height: 35px;
    }

    &:hover {
      color: #3B6152;
    }
  }
}
.offer-image {
  width: 360px;
  height: 428px;
  max-width: 100%;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 206px;
    max-width: calc(100% - 20px);
  }

  @media screen and (max-width: 480px) {
    max-width: calc(100% - 10px);
  }
}
.offer-title {
  margin-top: 10px;
  text-transform: uppercase;
  height: 50px;
}
.cta-button {
  background-color: #3B6152;;
  color: white;
  padding: .8rem 2rem;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
  font-family: $Raleway;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  transition: background-color .3s;
  @media screen and (max-width: 768px) {
    width: 325px;;
    height: 46px;
    padding: 0;
    font-size: 14px;
  }
}
.learn-more {
  color: #090808;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 25px;
}
.learn-more:hover {
  text-decoration: underline;
}
.address-p {
  padding-left: 15%;
  padding-right: 15%;

  @media screen and (max-width: 768px) {
    padding-left: 5%;
    padding-right: 5%;
  }
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #707070;
  }
}

.back-button-login {
  padding-left: 140px;
}

input[type=checkbox]:checked + label::before {
  background-color: #3B6152;
}
</style>
